import classNames from "classnames";
import React, { Children, HTMLAttributes, PropsWithChildren } from "react";

import { StepBar, StepChild, StepCircle, StepContent, StepDotWrapper, StyledDotStep } from "./DotSteps.styled";

const DotStepsComp = React.forwardRef<HTMLDivElement, PropsWithChildren<HTMLAttributes<HTMLDivElement>>>(
  (props, ref) => {
    const { children, className, ...restProps } = props;
    const dotStepsClass = classNames("c-dot-steps", className);

    return (
      <StyledDotStep data-testid="qa-dotsteps" ref={ref} className={dotStepsClass} {...restProps}>
        {Children.map(children, (child) => (
          <StepDotWrapper data-testid="qa-dotsteps-step" className="c-dot-steps__wrapper">
            <StepBar className="c-dot-steps__bar" />
            <StepCircle className="c-dot-steps__circle" />
            <StepContent className="c-dot-steps__content">{child}</StepContent>
          </StepDotWrapper>
        ))}
      </StyledDotStep>
    );
  }
);

const DotSteps = Object.assign(DotStepsComp, { Content: StepChild });

export default DotSteps;
